import UtilitiesStratto from "./UtilitiesStratto";

export default UtilitiesStratto;
